import DefaultScreenSizeTheme from 'assets/styles/themes/DefaultScreenSizeTheme'

//Styles for Dialog and footer action for mobile and large screen
export const sxDialog = {
  minHeight: '17rem',
  [DefaultScreenSizeTheme.breakpoints.down('sm')]: {
    maxHeight: '100%',
    position: 'relative',
    top: 0,
    marginTop: 'auto',
  },
  width: '100%',
  marginTop: '40px',
  maxHeight: 'calc(100vh - 150px)',
  padding: '0rem 0rem 1.5rem',
  position: 'fixed',
  top: '3.125rem',
  borderRadius: '0.5rem',
  zIndex: 9999999,
}

export const sxTwoActionBtn = {
  pb: 0,
  px: 3,
  pt: 3,
  [DefaultScreenSizeTheme.breakpoints.down('sm')]: {
    justifyContent: 'space-between',
    pt: 3,
    pb: 1,
  },
}

export const sxPrimaryActionBtn = {
  pb: 0,
  px: 3,
  pt: 3,
  [DefaultScreenSizeTheme.breakpoints.down('sm')]: {
    justifyContent: 'flex-end',
    pt: 3,
    pb: 1,
  },
}

export const sxCloseIcon = {
  position: 'absolute',
  top: '0.5rem',
  right: '0.5rem',
  [DefaultScreenSizeTheme.breakpoints.down('xs')]: {
    top: '1.25rem',
  },
}

export const sxDialogTitle = {
  pl: 3,
  pr: 3,
  pt: 4,
  pb: 3,
  [DefaultScreenSizeTheme.breakpoints.down('xs')]: {
    marginTop: '0.75rem',
  },
}
